"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-three/sections/healthSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

export type HomeThreeHealthSectionGeneratedProps = {
    sectionDiv0Div0Div0ClassName?: string;
    /** Default: "fade-up" */
    sectionDiv0Div0Div0Div0Div0DivDataAos?: string;
    /** Default: "Want More Dental" */
    sectionDiv0Div0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Health Tips?" */
    sectionDiv0Div0Div0Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "Subscribe to our newsletter for expert advice delivered to your inbox" */
    sectionDiv0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "Enter your email" */
    sectionDiv0Div0Div0Div0Div1Input0InputPlaceholder?: string;
    /** Default: "#" */
    sectionDiv0Div0Div0Div0Div1Link0LinkHref?: string;
    sectionDiv0Div0Div0Div0Div1Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div0Div1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "support-img" */
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/support-img-1.png" */
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "suport" */
    sectionDiv0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/support-img-1.png" */
    sectionDiv0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "suport" */
    sectionDiv0Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/support-img-2.png" */
    sectionDiv0Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "suport" */
    sectionDiv0Div0ImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/support-img-3.png" */
    sectionDiv0Div0ImageWithBasePath2ImageSrc?: string;
    sectionDiv0Div0ImageWithBasePath2ImageVisible?: boolean;
    sectionDiv0Div0ImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0ImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "suport" */
    sectionDiv0Div0ImageWithBasePath3ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/support-img-4.png" */
    sectionDiv0Div0ImageWithBasePath3ImageSrc?: string;
    sectionDiv0Div0ImageWithBasePath3ImageVisible?: boolean;
    sectionDiv0Div0ImageWithBasePath3ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0ImageWithBasePath3ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
};

const HomeThreeHealthSectionGenerated: FC<HomeThreeHealthSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0DivDataAos = "fade-up",
    sectionDiv0Div0Div0Div0Div0H20H2Text = "Want More Dental",
    sectionDiv0Div0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0Div0H20Span0SpanText = "Health Tips?",
    sectionDiv0Div0Div0Div0Div0P0PText = "Subscribe to our newsletter for expert advice delivered to your inbox",
    sectionDiv0Div0Div0Div0Div1Input0InputPlaceholder = "Enter your email",
    sectionDiv0Div0Div0Div0Div1Link0LinkHref = "#",
    sectionDiv0Div0Div0Div0Div1Link0LinkVisible,
    sectionDiv0Div0Div0Div0Div1Link0LinkRenderer,
    sectionDiv0Div0Div0Div0Div1Link0LinkProps,
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt = "support-img",
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/support-img-1.png",
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0ImageWithBasePath0ImageAlt = "suport",
    sectionDiv0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/support-img-1.png",
    sectionDiv0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0ImageWithBasePath1ImageAlt = "suport",
    sectionDiv0Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/support-img-2.png",
    sectionDiv0Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div0ImageWithBasePath2ImageAlt = "suport",
    sectionDiv0Div0ImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/support-img-3.png",
    sectionDiv0Div0ImageWithBasePath2ImageVisible,
    sectionDiv0Div0ImageWithBasePath2ImageRenderer,
    sectionDiv0Div0ImageWithBasePath2ImageProps,
    sectionDiv0Div0ImageWithBasePath3ImageAlt = "suport",
    sectionDiv0Div0ImageWithBasePath3ImageSrc = "/Templates/Doccure/img/bg/support-img-4.png",
    sectionDiv0Div0ImageWithBasePath3ImageVisible,
    sectionDiv0Div0ImageWithBasePath3ImageRenderer,
    sectionDiv0Div0ImageWithBasePath3ImageProps,
    sectionDiv0Div0Div0ClassName,
}) => {
    return (
        <section className="health-section-three section pt-0">
            <div className="container">
                <div className="support-item-list">
                    <div className={sectionDiv0Div0Div0ClassName ?? "row align-items-center"}>
                        <div className="col-lg-6">
                            <div className="section-header section-header-three aos" data-aos={sectionDiv0Div0Div0Div0Div0DivDataAos}>
                                {renderNode(sectionDiv0Div0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0Div0H20H2Renderer, (
                                    <h2 className="section-title" {...(sectionDiv0Div0Div0Div0Div0H20H2Props ?? {})}>
                                        {" "}
                                        {sectionDiv0Div0Div0Div0Div0H20H2Text}
                                        <span className="d-block">{sectionDiv0Div0Div0Div0Div0H20Span0SpanText}</span>
                                        {" "}
                                    </h2>
                                ))}
                                <p className="subtitle">{sectionDiv0Div0Div0Div0Div0P0PText}</p>
                            </div>
                            <div className="support-item-three">
                                <input type="text" className="inpts" placeholder={sectionDiv0Div0Div0Div0Div1Input0InputPlaceholder} />
                                {renderNode(sectionDiv0Div0Div0Div0Div1Link0LinkVisible, sectionDiv0Div0Div0Div0Div1Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div0Div0Div1Link0LinkHref} className="submit btn" {...(sectionDiv0Div0Div0Div0Div1Link0LinkProps ?? {})}>
                                        {" "}
                                        <i className="isax isax-arrow-right-1" />
                                    </SmartLink>
                                ))}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="support-img">
                                {renderNode(sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                                <div className="support-bottom" />
                            </div>
                        </div>
                    </div>
                    {renderNode(sectionDiv0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0ImageWithBasePath0ImageRenderer, (
                        <SmartImage src={sectionDiv0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-2" {...(sectionDiv0Div0ImageWithBasePath0ImageProps ?? {})} />
                    ))}
                    {renderNode(sectionDiv0Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0ImageWithBasePath1ImageRenderer, (
                        <SmartImage src={sectionDiv0Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0ImageWithBasePath1ImageAlt} className="img-fluid img-3" {...(sectionDiv0Div0ImageWithBasePath1ImageProps ?? {})} />
                    ))}
                    {renderNode(sectionDiv0Div0ImageWithBasePath2ImageVisible, sectionDiv0Div0ImageWithBasePath2ImageRenderer, (
                        <SmartImage src={sectionDiv0Div0ImageWithBasePath2ImageSrc} alt={sectionDiv0Div0ImageWithBasePath2ImageAlt} className="img-fluid img-4" {...(sectionDiv0Div0ImageWithBasePath2ImageProps ?? {})} />
                    ))}
                    {renderNode(sectionDiv0Div0ImageWithBasePath3ImageVisible, sectionDiv0Div0ImageWithBasePath3ImageRenderer, (
                        <SmartImage src={sectionDiv0Div0ImageWithBasePath3ImageSrc} alt={sectionDiv0Div0ImageWithBasePath3ImageAlt} className="img-fluid img-5" {...(sectionDiv0Div0ImageWithBasePath3ImageProps ?? {})} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HomeThreeHealthSectionGenerated;
